const Footer = () => {
  return (
    <>
      {/* Main Footer */}
      <footer className="main-footer">
        <strong>Copyright © {new Date().getFullYear()}.</strong> Tous droits
        réservés.
        <div className="float-right d-none d-sm-inline-block">
          {/* <b>Version</b> 3.2.0 */}
        </div>
      </footer>
    </>
  );
};

export default Footer;
